import {stringify} from 'query-string';
import {get} from 'svelte/store';
import {goto} from '@sapper/app';
import {PATHS} from '@/const';
import {envUtil} from '@/helper/env';
import {bridge} from '@/helper/bridge';
import {drawerUtil} from '@/helper/drawer';
import {getLocationSeachParam} from '@/helper/url';
import {pixelTrackRegister} from '@/da/pixel';
import {hasUsedUID} from '@/storage/uids';
import {fixLink$} from '@/store/lang';
import {setRedirectTarget} from '@/modules/header/util';

export const loginUtil = {
  loginOrRegister(width, fixLink, LG, tzTarget) {
    if (envUtil.isApp) {
      if (hasUsedUID()) {
        bridge.postMessage('toLogin');
        return;
      }
      bridge.postMessage('toRegister');
      return;
    }
    const target = tzTarget ? tzTarget : location.origin + fixLink(PATHS.HOME.pathname);
    if (hasUsedUID()) {
      if (width < 640) {
        goto(fixLink(PATHS.LOGIN.pathname) + '?' + stringify({target, action: 'Target'}));
        return;
      }
      drawerUtil.launchLogin(LG, target);
      return;
    }
    if (width < 640) {
      goto(fixLink(PATHS.REGISTER.pathname) + '?' + stringify({target, action: 'Target'}));
      return;
    }
    drawerUtil.launchRegister(LG, target);
  },
  loginOrRegisterForCompatible(width, fixLink, LG, tzTarget) {
    if (envUtil.isApp) {
      if (hasUsedUID()) {
        bridge.postMessage('toLogin');
        return;
      }
      bridge.postMessage('toRegister');
      return;
    }
    const target = tzTarget ? tzTarget : location.origin + fixLink(PATHS.HOME.pathname);
    if (width < 640) {
      goto(fixLink(PATHS.LOGIN.pathname) + '?' + stringify({target, action: 'Target'}));
      return;
    }
    if (hasUsedUID()) {
      drawerUtil.launchLogin(LG, target);
      return;
    }
    drawerUtil.launchRegister(LG, target);
  },
};

function redirectTarget() {
  const target = getLocationSeachParam('target');
  if (target) {
    window.location.href = target;
    return true;
  }
}

export async function handleLoginSuccess(isPop = false, isOauth = false, connector = 'MetaMask') {
  await pixelTrackRegister(connector);
  const fixLink = get(fixLink$);
  if (isOauth) {
    goto(fixLink(PATHS.OAUTH_AUTHORIZE.pathname) + window.location.search + '&status=logged');
    return;
  }
  if (redirectTarget()) {
    return;
  }
  if (isPop) {
    window.location.reload();
    return;
  }
  goto(fixLink(PATHS.ACCOUNT_OVERVIEW.pathname));
}

export function navAfterRegisterSuccess(target) {
  if (target) {
    window.location.href = target;
    return;
  }
  const fixLink = get(fixLink$);
  goto(fixLink(PATHS.ACCOUNT_OVERVIEW.pathname));
}

export function checkTarget(target) {
  if (!target) {
    return false;
  }

  if (target.indexOf('@') > -1) {
    return false;
  }

  if (/^https?:/.test(target)) {
    const targetUrl = new URL(target);
    return targetUrl.host === location.host;
  }

  return true;
}

export function gotoLoginPage(target) {
  const fixLink = get(fixLink$);
  if (target) {
    setRedirectTarget(target);
  }
  goto(fixLink(PATHS.LOGIN.pathname));
}

export function gotoRegisterPage(target) {
  const fixLink = get(fixLink$);
  if (target) {
    setRedirectTarget(target);
  }
  goto(fixLink(PATHS.REGISTER.pathname));
}

export function gotoLoginPageWithRedirect(target) {
  const fixLink = get(fixLink$);
  if (target) {
    setRedirectTarget(target);
  }
  goto(fixLink(PATHS.LOGIN.pathname));
}
